import { render, staticRenderFns } from "./branch-form.vue?vue&type=template&id=10d1d146"
import script from "./branch-form.vue?vue&type=script&lang=js"
export * from "./branch-form.vue?vue&type=script&lang=js"
import style0 from "./branch-form.vue?vue&type=style&index=0&id=10d1d146&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports